import { render } from "./BuzzNotifications.vue?vue&type=template&id=6c0928f6&scoped=true"
import script from "./BuzzNotifications.vue?vue&type=script&lang=js"
export * from "./BuzzNotifications.vue?vue&type=script&lang=js"

import "./buzz-notifications.scss?vue&type=style&index=0&id=6c0928f6&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0928f6"]])

export default __exports__